import React from 'react';
import { ImageProps } from '@/utils/types/ImageProps';
import { Media, MediaItem } from '@/utils/types/Media';
import { lmLength } from '@/utils/helpers';
import '@/styles/components/image.scss';

const Image: React.FC<ImageProps> = ( { 
    image, 
    height,
    id = '', 
    imageDataAttr = {}, 
    mobileImage,
    size = '', 
    url = '', 
    width,
    wrapperDataAttr = {}, 
} ) => {
    const type = image.type;
    const finalSize: string | undefined = type === 'image' ? ( size ? size : 'full' ) : undefined;
    const sizedImage: MediaItem | Media | undefined = finalSize ? ( image[ size ] ? image[ size ] as MediaItem : undefined ) : image;
    if ( lmLength( sizedImage ) || lmLength( url ) ) {
        const isIcon: boolean = type === 'icon';
        const wrapperClasses = [ 'lm-image-wrapper' ];
        const imageURL: string = sizedImage ? ( isIcon ? '' : ( sizedImage.url ? sizedImage.url as string : '' ) ) : ( url ? url : '' );
        const imageIsSVG: boolean = isIcon ? true : imageURL.indexOf( '.svg' ) > -1;
        const imageWidth: number | undefined = isIcon ? 50 : ( width ? width : ( sizedImage ? sizedImage.width as number : undefined ) );
        const imageHeight: number | undefined = isIcon ? 50 : ( height ? height : ( sizedImage ? sizedImage.height as number : undefined ) );
        const useImagePadding: boolean = imageIsSVG || [ 'full', 'large', 'medium', 'small' ].indexOf( size ) > -1 || Boolean( width );
        const mobileImageDetails: MediaItem | undefined = mobileImage && image[ mobileImage ] ? image[ mobileImage ] as MediaItem : ( ! isIcon && imageWidth && imageWidth >= 600 ? image[ size.replace( /(600|1000)/, '400' ) ] as MediaItem : undefined );
        const mobileImageURL: string | undefined = mobileImageDetails ? mobileImageDetails.url : ( isIcon ? undefined : imageURL );
        const imageClasses: Array<string> = [ 'lm-image' ];
        imageClasses.push( size );
        if ( id ) {
            wrapperDataAttr.id = id;
        }

        if ( imageIsSVG ) {
            wrapperClasses.push( 'lm-svg-wrapper' );
            imageClasses.push( 'lm-svg' );
        }
        let styleObject: Record<string, string>;
        styleObject = { 
            '--background-image': `url( ${ imageURL } )`, 
            '--mobile-background-image': `url("${ mobileImageURL }")`,
        };
        if ( useImagePadding && imageHeight && imageWidth ) {
            styleObject.paddingTop = ( imageHeight / imageWidth ) * 100 + '%'
        }
        return (
            <span className={ wrapperClasses.join( ' ' ) } style={ { width: imageWidth ? imageWidth + 'px' : '' } } { ...wrapperDataAttr }>
                <figure className={ imageClasses.join( ' ' ) } style={ styleObject } { ...imageDataAttr }></figure>
            </span>
        )
    } else {
        return null;
    }
}
export default Image;